// extracted by mini-css-extract-plugin
module.exports = {"privacy":"Accessibility_privacy__3Gw85"};